import { jsx } from 'react/jsx-runtime';
import { lazy, Suspense } from 'react';
import { useApp } from '@backstage/core-plugin-api';

const RealLogViewer = lazy(
  () => import('./RealLogViewer.esm.js').then((m) => ({ default: m.RealLogViewer }))
);
function LogViewer(props) {
  const { Progress } = useApp().getComponents();
  return /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(Progress, {}), children: /* @__PURE__ */ jsx(RealLogViewer, { ...props }) });
}

export { LogViewer };
//# sourceMappingURL=LogViewer.esm.js.map
